/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (outbox) {
  if (outbox.length > 0) {
    return [outbox[0]];
  }
  return [];
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-offline/lib/defaults/batch.js
// module id = 979
// module chunks = 76